import { rankingCommonConfig } from './common'
import { theme as brandTheme } from '@/config/brands'

/**
 * Storlyn 品牌排行榜页面配置
 */
export const rankingConfig = {
  ...rankingCommonConfig,
  theme: {
    rankGradient: 'none',
    medalNumberTop: '-2px',
    tabActiveColor: brandTheme.primaryColor,
    tabInactiveColor: brandTheme.textSecondary,
    medalBg: brandTheme.bgCard,
    cardBg: brandTheme.bgCard,
    cardBorder: brandTheme.borderPrimary,
  },
  resources: {
    homeBg: '',
    spikeletL: '',
    spikeletR: '',
    goldMedal: '/images/storlyn/ranking/rank-badge-gold.svg',
    silverMedal: '/images/storlyn/ranking/rank-badge-silver.svg',
    bronze: '/images/storlyn/ranking/rank-badge-bronze.svg',
    medal: '/images/storlyn/ranking/rank-badge-default.svg',
  },
}
